import { useEffect, useState } from 'react';
import { loadAskVocabulary } from '../../../lib/backOfficeApi';

/** The ask vocabulary, fetched once per page load and shared by every surface that scopes a question. */
let pending = null;
export const askVocabulary = () => (pending ||= loadAskVocabulary().catch((e) => { pending = null; throw e; }));
export function useAskVocabulary() {
  const [vocab, setVocab] = useState(null);
  useEffect(() => { let live = true; askVocabulary().then((v) => live && setVocab(v)).catch(() => {}); return () => { live = false; }; }, []);
  return vocab;
}
